<template>
    <div>
        <div class="seachBox flex">
            <div class="seachList"><span class="name">类型名称：</span>
                <a-input placeholder="请输入类型名称" class="seachs" v-model="seach.name"/>
            </div>
          <div class="seachList"><span class="name">所属板块：</span>
            <a-select v-model="seach.category" class="seachs" placeholder="请选择" allowClear>
              <a-select-option :value="item.id" :key="item.id" v-for="item in seachList">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
            <div class="seachList  ">
                <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                    查询
                </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" >
             <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
            <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')" />
      </span>
            <span slot="action" slot-scope="text, record">

        <a @click="(record)=>{visible = true;; title=' 编辑指令'; editId=text.id ; }" >编辑</a>

      </span>
        </a-table>
        <ArticleForm :visible="visible" :title="title" :editId="editId"
                     @changVisible=" () => { this.visible = false;this.editId=''; this.getList()}  "/>

    </div>
</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import ArticleForm from "./components/articleForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "类型名称",
            dataIndex: "name",
            ellipsis: true,width: "150px",
            key: "name"
        },
        {
            title: "所属板块",
            dataIndex: "category",
            ellipsis: true,width: "150px",
            key: "category",
        },
        {
            title: "指令词",
            dataIndex: "word",
            ellipsis: true,width: "150px",
            key: "word"
        },

        {
            title: "指令",
            dataIndex: "instruct",
            // ellipsis: true,
            key: "instruct",
        },  {
        title: "备注",
        dataIndex: "remark",width: "150px",
        ellipsis: true,
        key: "remark",
      },

        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return {
                resetSeachdata:true,
                fieldNames: {label: 'name', value: 'id', children: 'children'},
                visibleImg: false,
                tableImg: "",
                seachList:[],
                seach: {
                    name: "",
                    category: undefined
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                visible: false,
                title: "",
                editId: null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/ai/smartGenerate"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
          this.getSeach()
        },
        components: {ArticleForm},
        computed: {

        },
        methods: {

            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },

            resetSeach() {
                this.loading = true
                this.seach = {
                  name: "",
                  category: undefined
                }
                this.resetSeachdata=false
                this.getList(1)
            },



    getSeach() {
      API.service.GET_SEACH().then(res => {
        this.seachList = res.data.data,
        this.selectedRowKeys=[]
        if(!this.resetSeachdata==true)this.seach.update_time=[]
        this.resetSeachdata=true
        this.loading = false
      })
    },

            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.seach))


                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data
                    this.resetSeachdata=true
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            editLanguage(name, type) {
                if (type == '5') {
                    this.confirm(this.selectedRowKeys)
                }
                let url
                let dataArr = []
                let dataJson = {}
                this.selectedRowKeys.map((item, index) => {
                    dataJson = {}
                    dataJson.id = item;
                    dataJson[name] = type;
                    dataArr.push(dataJson)
                })
                if (name == 'status') {
                    orderList(API.service.CHANG_STATUS, dataArr).then(res => {
                        if (res == true) {
                            this.getList()
                            this.selectedRowKeys = []
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
